import React from 'react';

const Hours = props => {

    const { isChecked, time, type, index, updateHandler, isDisabled } = props;

    return (
        <select value={ time ? time : 'select' } disabled={isChecked || isDisabled } onChange={(e) => updateHandler(e, index, type) } >
            <option value='select'>Select</option>
            <option value='00:00'>12:00 AM</option>
            <option value='01:00'>1:00 AM</option>
            <option value='02:00'>2:00 AM</option>
            <option value='03:00'>3:00 AM</option>
            <option value='04:00'>4:00 AM</option>
            <option value='05:00'>5:00 AM</option>
            <option value='06:00'>6:00 AM</option>
            <option value='07:00'>7:00 AM</option>
            <option value='08:00'>8:00 AM</option>
            <option value='09:00'>9:00 AM</option>
            <option value='10:00'>10:00 AM</option>
            <option value='11:00'>11:00 AM</option>
            <option value='12:00'>12:00 PM</option>
            <option value='13:00'>1:00 PM</option>
            <option value='14:00'>2:00 PM</option>
            <option value='15:00'>3:00 PM</option>
            <option value='16:00'>4:00 PM</option>
            <option value='17:00'>5:00 PM</option>
            <option value='18:00'>6:00 PM</option>
            <option value='19:00'>7:00 PM</option>
            <option value='20:00'>8:00 PM</option>
            <option value='21:00'>9:00 PM</option>
            <option value='22:00'>10:00 PM</option>
            <option value='23:00'>11:00 PM</option>
            <option value='closed'>Closed</option>
        </select>
    );
};



export default Hours;